<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <p-tabView>
      <p-tabPanel header="Reports">
        <div class="card cost-api-card" style="padding: 2rem; margin-left: 1rem;">
          <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true" collapseIcon="pi pi-chevron-circle-up">
            <p-accordionTab header="Daily Management Report" [selected]="true">
              <div>
                <button class="btn btn-primary" style="float: right; margin-bottom: 1rem;"
                  (click)="downloadDailyReports()"><i class="fa fa-download icons mr-2"></i>Download Daily
                  Report</button>
              </div>
              <table class="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>Email Id</th>
                    <th>Brand Name</th>
                    <th>Date</th>
                    <th>Time Spent</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of dailyReports; let i= index">
                    <td>{{items.User_Email_id}}</td>
                    <td>{{items.Brand_Name}}</td>
                    <td>{{items.Date}}</td>
                    <td>{{items.Time_Spent}}</td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab header="Weekly Individual subscriber report">
              <div>
                <button class="btn btn-primary" style="float: right; margin-bottom: 1rem;"
                  (click)="downloadMonthlyReports()"><i class="fa fa-download icons mr-2"></i>Download Weekly
                  Report</button>
              </div>
              <table class="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>Email Id</th>
                    <th>Brand Name</th>
                    <th>Date</th>
                    <th>Time Spent</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of weeklyReports; let i= index">
                    <td>{{items.User_Email_id}}</td>
                    <td>{{items.Brand_Name}}</td>
                    <td>{{items.Date}}</td>
                    <td>{{items.Time_Spent}}</td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
            <p-accordionTab header="Queries & Responses">
              <div>
                <button class="btn btn-primary" style="float: right; margin-bottom: 1rem;"
                  (click)="downloadQuiryReports()"><i class="fa fa-download icons mr-2"></i>Download Monthly
                  Report</button>
              </div>
              <table class="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>Email Id</th>
                    <th>Technical Quiries</th>
                    <th>Development Resource Assistance</th>
                    <th>Subject</th>
                    <th>Describe The Issue</th>
                    <th>Upadted Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of quiriesReports; let i= index">
                    <td>{{items.User_ID}}</td>
                    <td>{{items.Technical_queries}}</td>
                    <td>{{items.Development_resource_assistance}}</td>
                    <td>{{items.Subject}}</td>
                    <td>{{items.Describe_the_issue}}</td>
                    <td>{{items.updated_time}}</td>
                  </tr>
                </tbody>
              </table>
            </p-accordionTab>
          </p-accordion>

        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

</div>